import { Link } from "react-router-dom";
import LegalDocumentPage from "../components/LegalDocumentPage";
import { LEGAL_OPERATOR, LEGAL_PUBLIC_LINKS } from "../content/legalMeta";
import { PRIVACY_SECTIONS } from "../content/privacyContent";
import "../pages/app-workspace.css";

export default function Confidencial() {
  return (
    <LegalDocumentPage
      standalone
      title="Политика конфиденциальности"
      subtitle="Обработка и защита персональных данных в соответствии с ФЗ-152"
      heroLead={
        <>
          Политика описывает, какие данные собираются при использовании
          платформы InChat, для каких целей они обрабатываются и какие права
          есть у Пользователя. Использование сервиса означает согласие с{" "}
          <Link to="/oferta">Публичной офертой</Link> и Правилами сервиса.
        </>
      }
      sections={PRIVACY_SECTIONS}
      footerLinks={LEGAL_PUBLIC_LINKS.filter(
        (link) => link.href !== "/politic-confidencial"
      )}
      footerNote={
        <>
          Обращения по персональным данным:{" "}
          <a href={`mailto:${LEGAL_OPERATOR.email}`}>{LEGAL_OPERATOR.email}</a>
          {" · "}
          <a
            href={LEGAL_OPERATOR.telegramUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {LEGAL_OPERATOR.telegram}
          </a>
        </>
      }
    />
  );
}
